import { required, schema, validate } from '@angular/forms/signals';
import { passwordValidator } from '@shared/utils/validators.util';

export type ChangePasswordModel = {
  old_password: string;
  new_password: string;
  confirm_password: string;
};

export const changePasswordSchema = schema<ChangePasswordModel>((rootPath) => {
  required(rootPath.old_password, { message: 'VALIDATION.REQUIRED' });
  required(rootPath.new_password, { message: 'VALIDATION.REQUIRED' });
  required(rootPath.confirm_password, { message: 'VALIDATION.REQUIRED' });

  validate(rootPath.new_password, (ctx) => passwordValidator(ctx.value()));
  validate(rootPath.new_password, (ctx) => {
    const newPass = ctx.value();
    const oldPass = ctx.valueOf(rootPath.old_password);

    if (newPass && oldPass && newPass === oldPass) {
      return {
        kind: 'sameAsOld',
        message: 'CHANGE_PASSWORD.ERROR_SAME_AS_OLD',
      };
    }
    return null;
  });

  validate(rootPath.confirm_password, (ctx) => {
    const confirm = ctx.value();
    const newPass = ctx.valueOf(rootPath.new_password);

    if (confirm && newPass && confirm !== newPass) {
      return { kind: 'notMatch', message: 'VALIDATION.PASSWORD_MISMATCH' };
    }
    return null;
  });
});
